import { render, staticRenderFns } from "./MarketingSmsEditHeader.vue?vue&type=template&id=4bab13f1&scoped=true"
import script from "./MarketingSmsEditHeader.vue?vue&type=script&lang=js"
export * from "./MarketingSmsEditHeader.vue?vue&type=script&lang=js"
import style0 from "./MarketingSmsEditHeader.vue?vue&type=style&index=0&id=4bab13f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bab13f1",
  null
  
)

export default component.exports